import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Select,
    Input

} from "../../ui/ot";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { Upload, FileSpreadsheet, Check, X, AlertCircle, FileText, ArrowRight, TrashIcon } from "lucide-react"
import ExportExcelButton from "./export_excel_button";

import dayjs from 'dayjs';

const basicFilterSetting = ["branchcode", "time"]
const TableHoldingTotal = ({
    keyPrefix = "cataloging.serial_receive",
    filterSearchParams = [...basicFilterSetting],
    excelType = null
}) => {
    const [searchParams, setSearchParams] = useState({
        branchcode: null,
        start_time: filterSearchParams.includes("time") ? dayjs().startOf('year').format('YYYY-MM-DD') : null,
        end_time: filterSearchParams.includes("time") ? dayjs().endOf('year').format('YYYY-MM-DD') : null,
    })
    const actionRef = useRef(null);
    const columns = [
        {
            title: "分館代號",
            dataIndex: "branchcode",
            key: "branchcode",
        },
        {
            title: "分館",
            dataIndex: "branchname",
            key: "branchname",
        },
        {
            title: "館藏類型",
            dataIndex: "item_type",
            key: "item_type",
        },
        {
            title: "統計數量(冊)",
            dataIndex: "item_type_number",
            key: "item_type_number",
        },
    ];
    const HoldingTotalController = useCRUDController({
        apiRoute: "/koha/report/item/detail"
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });

    useEffect(() => {
        checkAll();
        libraryController.getData({})
    }, []);
    useEffect(() => {
        if (!!actionRef.current) {
            actionRef.current.onTableSearch()
        }
    }, [searchParams])

    return (
        <Row
            gutter={[10, 20]}
        >
            <Col span={24}>
                <ProTableOt
                    searchParams={searchParams}
                    rowKey={"id"}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    // headerTitle={<Typography.Title>{t('')}</Typography.Title>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {
                            ...searchParams
                        };
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return HoldingTotalController.getData({
                            ...newParams
                        })
                    }}
                    toolBarRender={() => {
                        return [
                            filterSearchParams.includes("time") ? <Col span={24}>
                                <Row gutter={[4, 4]} align={"middle"}>
                                    <Col>
                                        <Typography.P>
                                            建立日期:
                                        </Typography.P>
                                    </Col>
                                    <Col>
                                        <Input
                                            placeholder={"起"}
                                            type="date"
                                            value={searchParams?.start_time ? searchParams?.start_time : ""}
                                            onChange={(e) => {
                                                setSearchParams((pre) => {
                                                    if (dayjs(e.target.value).isBefore(dayjs(pre?.end_time, "YYYY-MM-DD"))) {
                                                        return {
                                                            ...pre,
                                                            start_time: dayjs(e.target.value).format("YYYY-MM-DD"),
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            start_time: pre?.end_time,
                                                            end_time: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    <Col>
                                        <Typography.Title level={4}>
                                            ~
                                        </Typography.Title>
                                    </Col>
                                    <Col>
                                        <Input
                                            placeholder={"訖"}
                                            type="date"
                                            value={searchParams?.end_time ? searchParams?.end_time : ""}
                                            onChange={(e) => {
                                                setSearchParams((pre) => {
                                                    if ((dayjs(e.target.value)).isBefore(pre?.start_time)) {
                                                        return {
                                                            ...pre,
                                                            start_time: e.target.value,
                                                            end_time: pre?.start_time,
                                                        }
                                                    }
                                                    else {
                                                        return {
                                                            ...pre,
                                                            end_time: e.target.value,
                                                        }
                                                    }

                                                })
                                            }}
                                        />
                                    </Col>
                                    {(searchParams.start_time || searchParams.end_time) &&
                                        <Col>
                                            <Button
                                                type={"icon"}
                                                onClick={() => {
                                                    setSearchParams((pre) => {
                                                        return {
                                                            ...pre,
                                                            start_time: undefined,
                                                            end_time: undefined
                                                        }
                                                    })
                                                }}>
                                                X
                                            </Button>
                                        </Col>
                                    }
                                </Row>
                            </Col> : <></>,
                            filterSearchParams.includes("branchcode") ? <Col>
                                <Row align={"middle"} gutter={[8, 8]}>
                                    <Col>
                                        分館篩選：
                                    </Col>
                                    <Col>
                                        <Select
                                            allowClear={true}
                                            defaultValue={searchParams?.branchcode}
                                            value={searchParams?.branchcode}
                                            onChange={(value) => {
                                                setSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        branchcode: value
                                                    }
                                                })
                                            }}
                                            options={libraryController?.ResponseData?.map((option) => {
                                                return {
                                                    label: `(${option?.branchcode})${option?.branchname}`,
                                                    value: option?.branchcode,
                                                }
                                            })}
                                        >
                                        </Select>
                                    </Col>
                                </Row>
                            </Col> : <></>,
                            <ExportExcelButton
                                excelType={
                                    excelType}
                                fileName={!excelType ? "館藏統計資料.xlsx" : "館藏新增量統計資料.xlsx"}
                                params={{
                                    ...searchParams
                                }}
                                apiPath="/koha/report/item/excel"
                            />
                        ];
                    }}
                    rowSelection={false}
                    manage_columns={true}

                />
            </Col>
        </Row>
    );
};

export { TableHoldingTotal };
